<template>
  <!-- Тулбар карты. Вертикальная колонка column-reverse (справа; на
       мобильном по центру высоты): первый в DOM - самый нижний. Сверху вниз:
       «Инструменты» (линейка, метка, редактор; для ролей - правка данных
       карты и отладка), затем вид карты: Компас, Местоположение, Слои
       (подложка 2D/3D и слои точек - единственное место переключения 3D). -->
  <div class="map-controls">
    <ToolMenu :items="toolItems" :any-active="toolsActive" @pick="$emit('pick-tool', $event)" />
    <span class="map-controls__divider" aria-hidden="true" />
    <button
      type="button"
      class="locate-btn"
      :class="{ 'locate-btn--active': rotationMode === 'compass' }"
      :aria-label="rotationLabel"
      :title="rotationLabel"
      @click="$emit('cycle-rotation')"
    >
      <Navigation2 v-if="rotationMode === 'compass'" class="locate-btn__icon" aria-hidden="true" />
      <Compass v-else class="locate-btn__icon" aria-hidden="true" />
    </button>
    <button
      type="button"
      class="locate-btn"
      :class="{ 'locate-btn--active': hasLocation }"
      :disabled="locating"
      :aria-label="t('map.locateMe')"
      :aria-pressed="hasLocation"
      :title="approximate ? t('map.locateMeApproximate') : t('map.locateMe')"
      @click="$emit('locate')"
    >
      <Loader2 v-if="locating" class="locate-btn__icon locate-btn__icon--spin" aria-hidden="true" />
      <LocateFixed v-else class="locate-btn__icon" aria-hidden="true" />
    </button>
    <MapLayersControl :is3D="is3D" @toggle-3d="$emit('toggle-3d')" />
  </div>
</template>

<script setup lang="ts">
import type { Component } from "vue";
import { useI18n } from "vue-i18n";
import { Compass, Loader2, LocateFixed, Navigation2 } from "lucide-vue-next";
import ToolMenu from "./ToolMenu.vue";
import MapLayersControl from "../MapLayersControl.vue";
import type { MapRotationMode } from "../../composables/useMapRotation3D";

defineProps<{
  toolItems: { key: string; label: string; icon: Component; active?: boolean; hidden?: boolean }[];
  toolsActive: boolean;
  rotationMode: MapRotationMode;
  rotationLabel: string;
  hasLocation: boolean;
  locating: boolean;
  approximate: boolean;
  is3D: boolean;
}>();
defineEmits<{
  (e: "cycle-rotation" | "locate" | "toggle-3d"): void;
  (e: "pick-tool", key: string): void;
}>();

const { t } = useI18n();
</script>
